export default {
  namespaced: true,
  inventory_brand_catalog: {
    menu: "Catálogo de Marcas",
    title: "Marca",
    name: "Nombre",
    created_at: "Creado",
    updated_at: "Actualizado",
  },
};
